<template>
  <v-layout>
    <div class="btn">
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        color="red"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="black" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-flex xs12 sm3 v-if="isCommentLoaded">
      <Comment />
    </v-flex>
    <v-flex xs12 sm6 v-if="isProjectLoaded ==true && checkProjectLimit()==true">
      <v-container grid-list-md>
        <v-card class="grey lighten-3">
          <v-card-title class="project">
            <div><span class="headline">Edit Project</span></div>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-select
                    v-model="projectData.project_language"
                    :rules="project_language"
                    :items="project_language_data"
                    item-text="name"
                    item-value="id"
                    box
                    label="Project language"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-select
                    v-model="projectData.project_type_id"
                    :items="indexData.projectType"
                    item-text="name"
                    item-value="id"
                    :rules="[(v) => !!v || 'Project Type is required!']"
                    @change="calculatedPrice"
                    box
                    label="Project Type"
                  ></v-select>
                </v-flex>
                <v-flex getGridEng>
                  <v-text-field
                    v-model="projectData.name"
                    box
                    label="Project Title"
                    :rules="[(v) => !!v || 'Project Title is required!']"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  getGridBn
                  v-if="
                    projectData.project_language == 2 ||
                    projectData.project_language == 3
                  "
                >
                  <v-text-field
                    v-model="projectData.name_bangla"
                    :rules="[(v) => !!v || 'Project title bangla is required']"
                    box
                    :disabled="isLanguageSelected"
                    label="Project Title Bangla"
                    @keypress="isLetter($event)"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex getGridEng>
                  <v-textarea
                    v-model="projectData.details"
                    box
                    label="Projects Details"
                    :rules="[(v) => !!v || 'Project Details is required!']"
                  ></v-textarea>
                </v-flex>
                <v-flex
                  getGridBn
                  v-if="
                    projectData.project_language == 2 ||
                    projectData.project_language == 3
                  "
                >
                  <v-textarea
                    v-model="projectData.details_bangla"
                    box
                    label="Projects Details Bangla"
                    @keypress="isLetter($event)"
                    :disabled="isLanguageSelected"
                  ></v-textarea>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="projectData.begin_date"
                        :rules="startTime"
                        box
                        label="Estimated Starting Time *"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="projectData.begin_date"
                      :min="new Date().toISOString().substr(0, 10)"
                      @change="save(date)"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-menu
                    ref="menu"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="projectData.end_date"
                        :rules="endTime"
                        box
                        label="Ending Time *"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="projectData.end_date"
                      :min="new Date().toISOString().substr(0, 10)"
                      @change="save(date)"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout wrap v-if="projectData.project_type_id == 3">
                <v-flex xs12 sm4 md4>
                  <v-checkbox
                    v-model="projectData.unlimited_task_duration"
                    label="Allow unlimited task duration"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout
                wrap
                v-if="projectData.unlimited_task_duration == false"
              >
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="projectData.duration_days"
                    box
                    label="Task Duration(Days)"
                    @keypress="isDigit($event)"
                    :disabled="isLanguageSelected"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="projectData.duration_hours"
                    box
                    label="Task Duration(Hours)"
                    @keypress="isDigit($event)"
                    :disabled="isLanguageSelected"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="projectData.duration_minutes"
                    :rules="time"
                    box
                    label="Task Duration(Minutes)"
                    @keypress="isDigit($event)"
                    :disabled="isLanguageSelected"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap v-if="projectData.project_type_id == 2">
                <v-flex xs12 sm3 md3>
                  <div class="title mt-3">Distance Radius</div>
                </v-flex>
                <v-flex xs12 sm1 md2>
                  <v-checkbox
                    v-model="projectData.edit_distance_radius"
                    @change="checkUncheckDistance"
                    label="Customize"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <v-text-field
                    v-model="projectData.visual_distance_km"
                    box
                    label="Visual distance(Km)"
                    :disabled="!projectData.edit_distance_radius"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <v-text-field
                    v-model="projectData.acceptance_distance_meter"
                    box
                    label="Acceptance distance(Meter)"
                    :disabled="!projectData.edit_distance_radius"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout
                wrap
                v-if="(projectData.project_type_id == 1 || projectData.project_type_id == 2 ) && hasPreSurvey()">
                <v-flex xs12 sm12 md12>
                  <v-checkbox
                    v-model="projectData.has_pre_survey"
                    label="Pre-Survey"
                    required
                    :disabled="isLanguageSelected"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout wrap v-if="projectData.has_pre_survey">
                <v-flex getGridEng>
                  <v-textarea
                    v-model="projectData.pre_survey_descriptions"
                    box
                    label="Pre Survey Details"
                  ></v-textarea>
                </v-flex>
                <v-flex
                  getGridBn
                  v-if="
                    projectData.project_language == 2 ||
                    projectData.project_language == 3
                  "
                >
                  <v-textarea
                    v-model="projectData.pre_survey_descriptions_bangla"
                    box
                    label="Pre Survey Details Bangla"
                    @keypress="isLetter($event)"
                    :disabled="isLanguageSelected"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-checkbox
              v-model="projectData.is_otp_required"
              label="OTP Verification required"
              required
              :disabled="isLanguageSelected" v-if="hasMobileOTPVerification()"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <button class="button" flat @click="submit">Save & next</button>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";
// import router from "@/router";
import Comment from "./Comment";
import utilities from "../../../api/utilities.js";

export default {
  components: {
    Comment,
  },
  data: () => ({
    // apiUrl: 'project-view',
    apiUrl: "project-type",
    editedIndex: -1,
    menu: false,
    menu1: false,
    date: null,
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 4000,
    allowedMaxProjectLimit:null,
    project_language_data: [
      { name: "English", id: 1 },
      { name: "Bangla", id: 2 },
      { name: "English & Bangla both", id: 3 },
    ],
    comment_length: 0,
    project_type: {},
    projectData: {
      name: "",
      name_bangla: "",
      project_type_id: "",
      details: "",
      details_bangla: "",
      begin_date: "",
      end_date: "",
      is_otp_required: false,
      project_language: "",
      duration_days: 0,
      duration_hours: 0,
      duration_minutes: 0,
      has_pre_survey: 0,
      pre_survey_descriptions: "",
      pre_survey_descriptions_bangla: "",
      visual_distance_km: null,
      acceptance_distance_meter: null,
      edit_distance_radius: false,
      unlimited_task_duration: false,
      id: null,
    },
    comments: {
      comment: "",
      final_comment: "",
    },
    defaultItem: {
      name: "",
      name_bangla: "",
      project_type_id: "",
      details: "",
      details_bangla: "",
      begin_date: "",
      end_date: "",
      is_otp_required: false,
      project_language: "",
      duration_days: 0,
      duration_hours: 0,
      duration_minutes: 0,
      has_pre_survey: 0,
      pre_Survey_description: "",
      pre_Survey_description_bangla: "",
      visual_distance_km: null,
      acceptance_distance_meter: null,
      edit_distance_radius: false,
      unlimited_task_duration: false,
    },
    submitData: {
      data: [],
    },
    valid: true,
    projecTitle: [(v) => !!v || "Project title is required"],
    projectType: [(v) => !!v || "Select a project type"],
    startTime: [(v) => !!v || "Enter project starting time"],
    endTime: [(v) => !!v || "Enter project ending time"],
    time: [(v) => !!v || "Time is required."],
    project_language: [(v) => !!v || "Project language is required."],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "subscriptionData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    isLanguageSelected() {
      if (this.projectData.project_language == "") {
        return true;
      } else {
        return false;
      }
    },
    getGridEng() {
      if (this.projectData.project_language == 1) {
        return "xs12 sm12 md12";
      } else {
        return "xs6 sm6 md6";
      }
    },
    getGridBn() {
      if (this.projectData.project_language == 2) {
        return "xs12 sm12 md12";
      } else {
        return "xs6 sm6 md6";
      }
    },

    isCommentLoaded: function () {
      if (typeof this.indexData.comment !== "undefined") {
        this.checkCommentLoaded();
        return true;
      } else {
        return false;
      }
    },
    isProjectLoaded: function () {
      this.checkProjectLoaded();
      if (typeof this.indexData.project_data !== "undefined") {
        return true;
      } else {
        return false;
      }
    },
    binding() {
      const binding = {};
      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menu1(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },

  created() {
    // this.$store.dispatch("setIndexData", [this.apiUrl]);
    var project_id_modify = JSON.parse(
      localStorage.getItem("project_id_modify")
    );
    // console.log(project_id_modify);
    this.$store.dispatch("indexData", ["project-info", project_id_modify]);
  },

  methods: {
    calculatedPrice(event) {
      let val = this.indexData.projectTypes[event - 1].min_price;
      this.projectData.visual_distance_km =
        this.indexData.nearbyRadius.visual_radius_km;
      this.projectData.acceptance_distance_meter =
        this.indexData.nearbyRadius.acceptance_radius_m;
      this.$cookie.set("min_price", val, 1);
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (!/^[A-Za-z]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    checkCommentLoaded() {
      if (typeof this.indexData.comment !== "undefined") {
        this.comments = this.indexData.comment;
        // console.log(CommentData);
        return true;
      } else {
        return false;
      }
    },
    checkProjectLoaded() {
      if (this.indexData.project_data) {
        if (this.indexData.project_data.create_project_json) {
          this.project_type = this.indexData.projectType;
          var create_project_dataSet = JSON.parse(
            this.indexData.project_data.create_project_json
          );
          this.projectData = create_project_dataSet;
          this.projectData.id = this.indexData.project_data.id;
          return true;
        }
      } else {
        return false;
      }
    },
    isDigit(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[0-9]+$/.test(char)) return false;
      // Match with regex
      else {
        this.digitValidate = true;
        e.preventDefault();
      } // If not match, don't add to input text
    },
    save(date) {
      this.$refs.menu.save(date);
      this.menu = false;
    },
    save1(date) {
      this.$refs.menu1.save1(date);
    },

    checkUncheckDistance() {
      if (this.projectData.edit_distance_radius == false) {
        this.projectData.visual_distance_km =
          this.indexData.nearbyRadius.visual_radius_km;
        this.projectData.acceptance_distance_meter =
          this.indexData.nearbyRadius.acceptance_radius_m;
      }
    },

    close() {
      setTimeout(() => {
        this.projectData = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    checkProjectLimit() {
      // console.log('from allowedProjectLimit');
      this.allowedMaxProjectLimit = utilities.allowedProjectLimit(
        this.subscriptionData.subscriptionFeatures
      );
      if (this.allowedMaxProjectLimit) {
        return true;
      }
      return false;
    },
    hasPreSurvey() {
      if (utilities.hasPreSurvey(this.subscriptionData.subscriptionFeatures)) {
        return true;
      }
      return false;
    },
    hasMobileOTPVerification() {
      if (
        utilities.hasMobileOTPVerification(
          this.subscriptionData.subscriptionFeatures
        )
      ) {
        return true;
      }
      return false;
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.submitData.data = this.projectData;
        this.$store.dispatch("storeOrUpdateProjectModify", [
          "edit-project",
          this.submitData,
        ]);
        this.snackbar = true;
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 30px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>
